export const URL_RULES_OPTIONS = {
  All: 'all',
  Rules: 'rules',
  Labels: 'labels',
};

export const TARGET_TYPE = {
  Url: 'URL',
  PageTitle: 'PAGE_TITLE',
  PageContent: 'PAGE_CONTENT',
  Category: 'CATEGORY',
  CustomLabel: 'CUSTOM_LABEL',
};

export const CONDITION_OPERATOR = {
  Contains: 'Contains',
};

export const INPUT_VALIDATION_SCHEMA = {
  name: 'Url Rule Input',
  type: 'object',
  properties: {
    ruleInput1: {
      type: 'string',
      maxLength: 2048,
    },
    ruleInput2: {
      type: 'string',
      maxLength: 2048,
    },
    ruleInput3: {
      type: 'string',
      maxLength: 2048,
    },
  },
};
